import CollapseCustom from './CollapseCustom';

export default CollapseCustom;
